export default __webpack_public_path__ + "static/qrcode-scan.0f140e469f84f1083274312bd7b1a505.svg";